import { z } from 'zod';
import { Database } from 'libs/end-to-end/src/types/databases/database';

export const Databases = z.object({
  databases: z.array(Database),
});

export type Databases = z.infer<typeof Databases>;
